var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1154,
    height: 16,
    viewBox: "0 0 1154 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.724915 12.7246H1153.93V15.2695H5.90397L0.724915 12.7246Z",
    fill: "#003E6B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.724915,
    width: 1153.2,
    height: 12.7246,
    fill: "#668BA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShelf);
export default __webpack_public_path__ + "static/media/shelf.48b0023f5b8dcdd7ed10136d235b5d0c.svg";
export { ForwardRef as ReactComponent };